import { useEffect } from "react";
import { campaignsApi } from "screens/Campaigns/service";
import { useCampaignsStore } from "screens/Campaigns/store";
import { ICampaignsRule } from "screens/Campaigns/types";
import { CampaignsRule } from "../CampaignsRule";
import { Button } from "components/Button";
import { v4 as uuidv4 } from "uuid";

export const CampaignsRules = () => {
  const {
    selectedCampaigns: selectedCampaign,
    campaignRules: rules,
    setCampaignRules: setRules
  } = useCampaignsStore();

  const addNewRuleHandler = () => {
    const newRule: ICampaignsRule = {
      title: "",
      description: "",
      id: uuidv4()
    };
    setRules([...rules, newRule]);
  };

  const removeRuleHandler = async (rule: ICampaignsRule) => {
    const existingRule = selectedCampaign?.campaign_rules?.some(
      (r) => r.id === rule.id
    );

    if (existingRule) {
      rule.id && (await campaignsApi.deleteRule(rule.id));
    }

    const updatedRules = rules.filter((r) => r.id !== rule.id);
    setRules(updatedRules);
  };

  const saveRuleHandler = async (rule: ICampaignsRule) => {
    if (selectedCampaign) {
      const existingRule = selectedCampaign.campaign_rules?.some(
        (r) => r.id === rule.id
      );

      if (existingRule) {
        rule.id && (await campaignsApi.updateRule(rule, rule.id));
      } else {
        const createdRule = await campaignsApi.createRule(
          rule,
          selectedCampaign.id
        );

        if (createdRule) {
          setRules(rules.map((r) => (r.id === rule.id ? createdRule : r)));
        }
        return;
      }
    }

    setRules(rules.map((r) => (r.id === rule.id ? rule : r)));
  };

  useEffect(() => {
    setRules(selectedCampaign?.campaign_rules ?? []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCampaign]);

  return (
    <>
      {Boolean(rules.length) && (
        <div className="mt-6">
          <p className="ml-1 mb-1 text-[12px] leading-[17px] font-[500] text-[#FFFFFF99]">
            Rules
          </p>
          <div className="flex flex-col gap-6">
            {rules.map((rule, index) => (
              <CampaignsRule
                rule={rule}
                key={index}
                removeRule={removeRuleHandler}
                saveRule={saveRuleHandler}
              />
            ))}
          </div>
        </div>
      )}

      <div className="bg-gradient-to-t from-black to-transparent pt-6 flex items-center w-full">
        <Button extraClass="w-full" onClick={addNewRuleHandler}>
          <span className="mr-[10px] text-[18px]">+</span> Add new rule
        </Button>
      </div>
    </>
  );
};
